// Villager trade screen (VIL, M14.1). Lists the villager's offers (inputs →
// output, uses remaining), and clicking an affordable, in-stock offer executes
// the trade through game.doTrade. Client-only (ENG-1).
import { h, clear } from '../h';
import type { Game } from '../../boot';

const pretty = (name: string): string => name.replace(/_/g, ' ');

export function openTrade(game: Game, entityId: number): void {
  game.uiOpen = true;
  document.exitPointerLock();

  const overlay = h('div', { class: 'bb-window-overlay' });
  const panel = h('div', { class: 'bb-window', style: { minWidth: '340px' } });
  overlay.append(panel);
  document.body.append(overlay);

  const render = (): void => {
    clear(panel);
    const info = game.villagerInfo(entityId);
    panel.append(h('div', { class: 'bb-window-title' }, info ? `Trade — ${pretty(info.profession)}` : 'Trade'));
    const offers = game.villagerOffers(entityId);
    if (offers.length === 0) {
      panel.append(h('div', { style: { opacity: '0.7', padding: '8px 0' } }, 'This villager has nothing to trade.'));
    }
    offers.forEach((offer, i) => {
      const buys = offer.buy.map((b) => `${b.count} ${pretty(b.name)}`).join(' + ');
      const sell = `${offer.sell.count} ${pretty(offer.sell.name)}`;
      const locked = offer.used >= offer.maxUses;
      const enabled = offer.affordable && !locked;
      const row = h('button', {
        class: 'bb-btn',
        type: 'button',
        'data-slot': `trade-${i}`,
        style: {
          display: 'flex', width: '100%', gap: '10px', alignItems: 'center', margin: '4px 0',
          textAlign: 'left', opacity: enabled ? '1' : '0.5',
        },
      },
        h('span', { style: { flex: '1' } }, `${buys}  →  ${sell}`),
        h('span', { style: { opacity: '0.8', whiteSpace: 'nowrap' } }, locked ? 'out of stock' : `${offer.maxUses - offer.used}×`));
      row.addEventListener('mousedown', (e) => { e.preventDefault(); if (game.doTrade(entityId, i)) render(); });
      panel.append(row);
    });

    const close = h('button', { class: 'bb-btn', type: 'button', style: { marginTop: '10px' } }, 'Close');
    close.addEventListener('mousedown', (e) => { e.preventDefault(); doClose(); });
    panel.append(close);
  };

  let closed = false;
  const doClose = (): void => {
    if (closed) return;
    closed = true;
    document.removeEventListener('keydown', onKey, true);
    overlay.remove();
    game.uiOpen = false;
    void game.renderer.domElement.requestPointerLock();
  };
  const onKey = (e: KeyboardEvent): void => {
    if (e.code === 'Escape' || e.code === 'KeyE') { e.preventDefault(); e.stopPropagation(); doClose(); }
  };
  document.addEventListener('keydown', onKey, true);
  overlay.addEventListener('mousedown', (e) => { if (e.target === overlay) doClose(); });
  render();
}
